$(document).ready(function() {
  function stripeTokenHandler(token) {
    var form = document.getElementById("bank-form");
    var hiddenInput = document.createElement("input");
    hiddenInput.setAttribute("type", "hidden");
    hiddenInput.setAttribute("name", "stripe_token");
    hiddenInput.setAttribute("value", token.id);
    form.appendChild(hiddenInput);

    form.submit();
  }
  function stripeErrorHandler(error) {
    var form = document.getElementById("bank-errors");
    form.textContent = "";
    var errorParagraph = document.createElement("p");
    errorParagraph.setAttribute("class", "alert alert-danger");
    errorParagraph.innerText = error.message;
    form.appendChild(errorParagraph);
  }

  $("#bank-form").on("submit", function(event) {
    event.preventDefault();
    const stripe = Stripe(window.STRIPE_PUBLISHABLE_KEY);
    stripe
      .createToken("bank_account", {
        country: "US",
        currency: "usd",
        routing_number: $("#id_routing_number").val(),
        account_number: $("#id_account_number").val(),
        account_holder_name: $("#id_account_holder_name").val(),
        account_holder_type: $("#id_account_holder_type").val()
      })
      .then(function(result) {
        if (result.hasOwnProperty("token")) {
          stripeTokenHandler(result.token);
        } else {
          stripeErrorHandler(result.error);
        }
      });
  });
});
